import { useContext } from 'react';

import { ScenarioHeatmapContext } from '../context/ScenarioHeatmapContext';

export const useScenarioHeatmapContext = () => {
  const context = useContext(ScenarioHeatmapContext);

  if (!context)
    throw new Error(
      'useScenarioHeatmapContext needs to be used within ScenarioHeatmapContext.Provider!'
    );

  return context;
};
